// 我的模块导航
export const mineMenus = [
    // {
    //     title: '我的', key: 'mine_white',icon:'icon iconfont icon-qudao',compTypes:[1,3], children: [
    //         { title: '渠道白名单', key: '/mine/sale/white',compTypes:[3],icon:'icon iconfont icon-qudao' },
    //         { title: '渠道分组', key: '/mine/factory/white',compTypes:[1],icon:'icon iconfont icon-qudao' },
    //     ]
    // },
];